import React from 'react';
import _ from 'lodash'

export const ActivationDialog = (props) => {
    const { message, title, visible, onProceed, onCancel, isShowActivationButton } = props;

    if(!_.isNil(visible) && !visible) {
        return null;
    }
    return (
      <>
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  {title || "Confirmation"}
                </h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={onCancel}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {message || "Are you sure to perform this action?"}
              </div>
              <div className="modal-footer">
                {!isShowActivationButton  && <button
                  type="button"
                  className="btn btn-success"
                  onClick={onProceed}
                >
                    Activate
                </button>}
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={onCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" />
      </>
    );
}
